import { Commands } from '.';
var InputBox = (function () {
    function InputBox(data) {
        this.myInput = data.parameters.defaultResponse;
        this.myCaption = data.parameters.title;
        this.myText = data.parameters.prompt;
        this.myIcons = data.parameters.icons;
    }
    Object.defineProperty(InputBox.prototype, "name", {
        get: function () {
            return Commands.InputBox;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputBox.prototype, "input", {
        get: function () {
            return this.myInput;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputBox.prototype, "caption", {
        get: function () {
            return this.myCaption;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputBox.prototype, "text", {
        get: function () {
            return this.myText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputBox.prototype, "icons", {
        get: function () {
            return this.myIcons;
        },
        enumerable: false,
        configurable: true
    });
    return InputBox;
}());
export { InputBox };
